﻿/* 
Object:         NodeMove
Description:    Logic and events for node move
Used in:        NodeMove
*/

window.nodemove = function () {
    var newParentNodeId = -1;                                   // Current selected nodeid
    var expand_initial_treeview_nodeid = new Array();           // Expand towards a particulair node in the nodetree after loading
    var titleError, textError, textOk;                          // 

    return {
        /**
        * Select node (event raised when selecting a node in the kendo node tree). Only nodes that are not disabled by the css class are selectable. 
        * @param {Object} e
        */  
        selectNode: function (e) {
            if ($(e.node).hasClass('node-tree-item-disabled'))
            {
                e.preventDefault();
            }
            else
            {
                newParentNodeId = parseInt($(e.node).find('.data-id').val());
            }
        },

        /**
        * OnDataBound event (used to expand to a particular path (selected node in the current session.)).
        * @param {Object} e
        */
        onDataBound: function () {
            // Get treeNode.
            var treeview = $("#nodemove-node-tree-precom").data("kendoTreeView");

            // navigate (this ensures that the onDataBound is called many times...)
            treeview.expandPath(expand_initial_treeview_nodeid);

            // Opacity
            $(".node-tree-item-disabled").parent().parent().css("opacity", 0.2);
        },

        /**
        * Initialize.
        * @param {Object} e
        */
        initialize: function (jsonStr, titleErrorParam, textErrorParam, textOkParam) {
            titleError = titleErrorParam;
            textError = textErrorParam;
            textOk = textOkParam;

            // Format and set it ready for method: expandPath.
            var arr = new Array();

            // 
            for (var i = 0; i < jsonStr.length; i++) {
                arr.push(jsonStr[i].NodeId);
            }

            // 
            expand_initial_treeview_nodeid = arr;

            // event apply move
            $("#applyMove").click(function () {
                
                if (newParentNodeId != -1) {
                    $.ajax({
                        type: "POST",
                        url: appsettings.getUrl("NodeMove/Move"),
                        data: { newParentNodeId: newParentNodeId },
                        success: function (responseData) {

                            if (responseData.Succesfully) {
                                // reload nodetree
                                navigation.setFirstLoadPage(true);
                                navigation.refreshNodeTree();
                            }
                            else {
                                main.openActionsDialog(titleError,
                                    textError, [{
                                        text: textOk,
                                        action: function () {
                                            main.closePopup();
                                        }, primary: true
                                    }]);
                            }
                        }
                    });
                }

            });
        }
    }

}();